import { SVGProps } from 'react';
const SvgCheckAllBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7 12 4.95 4.95L22.556 6.343M2.05 12.05 7 17m5.303-5.303 5.304-5.303"
    />
  </svg>
);
export default SvgCheckAllBig;
